<template>
  <div class="ship_info">
    <div class="detail_container">
      <div class="detail_bar">基本信息</div>
      <div class="detail_one">
        <div class="detail_title">
          中文船名:
        </div>
        <div class="detail_value">
          {{ ship.name_cn || ship.name_en || '-' }}
        </div>
      </div>
      <div class="detail_one">
        <div class="detail_title">
          英文船名:
        </div>
        <div class="detail_value">
          {{ ship.name_en || '-' }}
        </div>
      </div>
      <div class="detail_one_hf">
        <div class="detail_title">
          MMSI:
        </div>
        <div class="detail_value">
          {{ ship.mmsi }}
        </div>
      </div>
      <div class="detail_one_hf">
        <div class="detail_title">
          IMO:
        </div>
        <div class="detail_value">
          {{ ship.imo || '-' }}
        </div>
      </div>
      <div class="detail_one_hf">
        <div class="detail_title">
          注册号:
        </div>
        <div class="detail_value">
          {{ ship.regist_number || '-' }}
        </div>
      </div>
      <div class="detail_one_hf">
        <div class="detail_title">
          呼号:
        </div>
        <div class="detail_value">
          {{ ship.callsign || '-' }}
        </div>
      </div>
      <div class="detail_one_hf">
        <div class="detail_title">
          船籍港:
        </div>
        <div class="detail_value">
          {{ ship.home_port || '-' }}
        </div>
      </div>
      <div class="detail_one_hf">
        <div class="detail_title">
          船旗:
        </div>
        <div class="detail_value">
          {{ ship.flag_name || ship.flag_name_en || '-' }}
        </div>
      </div>
      <div class="detail_one_hf">
        <div class="detail_title">
          船型:
        </div>
        <div class="detail_value">
          {{ ship.ship_type_others || '-' }}
        </div>
      </div>
      <div class="detail_one_hf">
        <div class="detail_title">
          长/宽(米):
        </div>
        <div class="detail_value">
          {{ ship.length/10 || '-' }} / {{ ship.width/10 || '-' }}
        </div>
      </div>
      <div class="detail_one_hf">
        <div class="detail_title">
          龙骨日期:
        </div>
        <div class="detail_value">
          {{ ship.date_keel_laid && ship.date_keel_laid != 0 ? new Date(ship.date_keel_laid*1000).toLocaleDateString() : '-' }}
        </div>
      </div>
      <div class="detail_one_hf">
        <div class="detail_title">
          建造日期:
        </div>
        <div class="detail_value">
          {{ ship.date_build && ship.date_build != 0 ? new Date(ship.date_build*1000).toLocaleDateString() : '-' }}
        </div>
      </div>
      <div class="detail_one_hf">
        <div class="detail_title">
          吃水(米):
        </div>
        <div class="detail_value">
          {{ ship.draught/10 || '-' }}
        </div>
      </div>
      <div class="detail_one_hf">
        <div class="detail_title">
          总吨:
        </div>
        <div class="detail_value">
          {{ ship.gt || ship.gt_final || '-' }}
          <div v-if="ship.gt !== ship.gt_final" class="ship_info_gt_pre" @click="gtalert">?</div>
        </div>
      </div>
      <div class="detail_bar">管理信息</div>
      <div class="detail_one">
        <div class="detail_title">
          船厂:
        </div>
        <div class="detail_value">
          {{ ship.builder || builder.builder_show_name || ship.builder_en || '-' }} {{ builder && builder.company_grade ? ('('+builder.company_grade + '类船厂)') : '' }}
        </div>
      </div>
      <div class="detail_one">
        <div class="detail_title">
          船公司:
        </div>
        <div class="detail_value">
          {{ ship.shipmanager_ch || ship.shipmanager_en || ship.name_show || '-' }}
        </div>
      </div>
      <div class="detail_one">
        <div class="detail_title">
          船级社:
        </div>
        <div class="detail_value">
          {{ ship.classification_society || '-' }}
        </div>
      </div>
      <div class="detail_one">
        <div class="detail_title">
          船舶证书:
        </div>
        <div class="detail_value">
          {{ '-' }}
        </div>
      </div>
      <div class="detail_one_hf">
        <div class="detail_title">
          信用评级:
        </div>
        <div class="detail_value">
          {{ credit.credit_letter || '-' }}
        </div>
      </div>
      <div class="detail_one_hf">
        <div class="detail_title">
          信用评分:
        </div>
        <div class="detail_value">
          {{ credit.credit_score || '-' }}
        </div>
      </div>
      <div class="detail_one">
        <div class="detail_title">
          Club:
        </div>
        <div class="detail_value">
          {{ clubs.club || '-' }}
        </div>
      </div>
      <div class="detail_one">
        <div class="detail_title">
          Member:
        </div>
        <div class="detail_value">
          {{ clubs.member || '-' }}
        </div>
      </div>
      <div class="detail_one">
        <div class="detail_title">
          Type:
        </div>
        <div class="detail_value">
          {{ clubs.type || '-' }}
        </div>
      </div>
      <div class="detail_one" style="text-align:center">
        <el-button type="info" size="small" @click="infoClose">关 闭</el-button>
      </div>
    </div>
  </div>
</template>

<script>
  import { getClubByImo,getBuilderByBuilderCleanId } from '../../api/api'
    export default {
      name: "info",
      props:{
          ship:{
            type:Object,
            value:{}
          },
          credit:{
            type:Object,
            value:{}
          }
      },
      data(){
        return {
          builder:{},
          clubs:{}
        }
      },
      mounted(){
        if(this.ship.imo && this.ship.imo > 0){
          getClubByImo(this.ship.imo).then(res => {
            if(res && res.status ===0 && res.data){
              this.clubs = res.data[0];
            }
          })
        }
        if(this.ship.builder_clean_id && this.ship.builder_clean_id > 0){
          getBuilderByBuilderCleanId(this.ship.builder_clean_id).then(res => {
            if(res && res.status === 0){
              this.builder = res.data;
            }
          });
        }
      },
      methods: {
        gtalert(){
          this.$notify({
            title:'吨位异常',
            message:'实际吨位数据缺失,当前显示的为预测吨位'
          })
        },
        infoClose(){
          this.$emit('shipInfoClose',null);
        }
      }
    }
</script>

<style scoped>
  .detail_bar {
    text-indent: 1rem;
    width:100%;
    float:left;
    height:2rem;
    font-size:1rem;
    line-height: 2rem;
    font-weight:bold;
    background-color:rgba(100,100,100,0.1);
    border:1px solid rgba(100,100,100,0.2)
  }

  .detail_one {
    width:90%;
    float:left;
    height:2.4rem;
    font-size:.8rem;
    font-weight:bold;
    margin:.2rem 5%;
    border-bottom:1px solid rgba(100,100,100,0.1)
  }

  .detail_one_hf {
    width:40%;
    float:left;
    height:2.4rem;
    font-size:.8rem;
    font-weight:bold;
    margin:.2rem 5%;
    border-bottom:1px solid rgba(100,100,100,0.1)
  }

  .detail_title {
    width:100%;
    color:rgba(100,100,100,0.5);
  }

  .detail_value {
    width:100%;
  }

  .ship_info_gt_pre {
    float:right;
    margin-right:.3rem;
    border-radius: 2rem;
    text-align: center;
    font-weight: bold;
    color:white;
    background-color:red;
    font-size:.65rem;
    width:.9rem;
    height:.9rem;
    line-height:.9rem;
  }
</style>



// WEBPACK FOOTER //
// src/components/ship/info.vue